
// src/pages/LoginPage/config.js
/**
 * Configurações da LoginPage
 */
export const loginConfig = {
  defaultTheme: 'lumen',
  toastTimeout: 3500,
  redirectPath: ({ account, project, formid }) => `/form/?account=${account}&project=${project}&formid=${formid}`,
};
